function getApiBase(): string {
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL;
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return "http://localhost:8787";
    }
  }
  return "https://landtrust-backend.pensive-kim.workers.dev";
}
export const API_BASE = getApiBase();

export class ApiError extends Error {
  status: number;
  code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
  }
}

/**
 * API 요청 래퍼
 * - 자동으로 broker_token을 Authorization 헤더에 추가
 * - 401 응답 시 토큰 삭제 + /login 리다이렉트
 */
export async function apiFetch<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const token = localStorage.getItem("broker_token");
  const headers: Record<string, string> = {
    ...(options?.headers as Record<string, string>),
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  if (options?.body && !(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  let res: Response;

  try {
    res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  } catch {
    throw new ApiError(
      0,
      "NETWORK_ERROR",
      "네트워크 연결을 확인해 주세요.",
    );
  }

  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as {
      error?: string;
      code?: string;
    };

    if (res.status === 401) {
      localStorage.removeItem("broker_token");
      localStorage.removeItem("broker_info");
      window.location.href = "/login";
      throw new ApiError(401, "UNAUTHORIZED", "로그인이 필요합니다");
    }

    throw new ApiError(
      res.status,
      body.code || "SERVER_ERROR",
      body.error || "서버 오류가 발생했습니다.",
    );
  }

  return res.json() as Promise<T>;
}
